import { MessageBox } from 'element-ui'
import router from "@/router-v2"

function createMessageBox() {
  MessageBox.confirm('<div>You Previous payment has failed.<br />Please continue the payment.</div>', 'Notice', {
    dangerouslyUseHTMLString: true,
    center: true,
    showClose: false,
    showCancelButton: false,
    distinguishCancelAndClose: true,
    closeOnClickModal: false,
    closeOnPressEscape: false,
    closeOnHashChange: false,
    confirmButtonText: 'Change Previous Order',
    beforeClose: (action, instance, done) => {
      console.log(done)
      if (action === 'confirm') {
        // 修改订单
        router.push('/self-order')
        done()
      }
    }
  }).then(() => {}).catch(() => {})
}

export default createMessageBox
